/**
 * Disqover Analytics Tracking Utility
 * Tracks user interactions for Creator Analytics Dashboard
 */

const API_URL = '';

// Get or create persistent session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('disqover_session_id');
  if (!sessionId) {
    sessionId = `sess_${Date.now().toString(36)}_${Math.random().toString(36).substr(2, 8)}`;
    sessionStorage.setItem('disqover_session_id', sessionId);
    
    // Track session start
    trackEvent('session_start');
  }
  return sessionId;
};

// Get QR source from URL params (if present)
const getQRSource = () => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('source') || params.get('qr') || params.get('ref');
  if (source) {
    sessionStorage.setItem('disqover_qr_source', source);
    return source;
  }
  return sessionStorage.getItem('disqover_qr_source') || 'direct';
};

// Track an analytics event
export const trackEvent = async (eventType, businessId = null, metadata = {}) => {
  try {
    const sessionId = getSessionId();
    const source = getQRSource();
    
    await fetch(`${API_URL}/api/analytics/platform/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        business_id: businessId,
        session_id: sessionId,
        metadata: {
          ...metadata,
          source,
          page_url: window.location.pathname,
          referrer: document.referrer || null,
        }
      })
    });
  } catch (error) {
    // Silent fail - don't block user experience
    console.debug('Analytics tracking error:', error);
  }
};

// Convenience methods for common events
export const analytics = {
  // Track QR code scan (call on app load if ?source= param present)
  trackQRScan: (source) => {
    trackEvent('qr_scan', null, { source });
  },
  
  // Track page view
  trackPageView: (pageName) => {
    trackEvent('page_view', null, { page_name: pageName });
  },
  
  // Track listing/business view
  trackListingView: (businessId) => {
    trackEvent('listing_view', businessId);
  },
  
  // Track call button click
  trackCallClick: (businessId) => {
    trackEvent('call_click', businessId);
  },
  
  // Track website button click
  trackWebsiteClick: (businessId) => {
    trackEvent('website_click', businessId);
  },
  
  // Track map open
  trackMapOpen: (businessId) => {
    trackEvent('map_open', businessId);
  },
  
  // Track direction request
  trackDirectionRequest: (businessId) => {
    trackEvent('direction_request', businessId);
  },
  
  // Track category view
  trackCategoryView: (category) => {
    trackEvent('category_view', null, { category });
  },
  
  // Track search
  trackSearch: (query) => {
    trackEvent('search', null, { query });
  },
  
  // Track favorite action
  trackFavorite: (businessId, action) => {
    trackEvent('favorite', businessId, { action }); // action: 'add' or 'remove'
  },
  
  // Initialize tracking on app load
  init: () => {
    const sessionId = getSessionId();
    const params = new URLSearchParams(window.location.search);
    const source = params.get('source') || params.get('qr') || params.get('ref');
    
    // If coming from QR code, track the scan
    if (source) {
      trackEvent('qr_scan', null, { source });
    }
    
    // Track initial page view
    trackEvent('page_view', null, { page_name: 'app_load' });
    
    return sessionId;
  }
};

export default analytics;
